import classNames from 'classnames'
import { useTheme } from '@homebot/shared-ui-swashbuckle'
import styles from './ListItem.module.scss'

export interface ListItemProps {
  children: React.ReactNode
  isActive?: boolean
  lastItem?: boolean
  onBlur?: () => void
  onClick?: (e) => void
  onFocus?: () => void
  onKeyDown?: (e) => void
}

export const ListItem = ({
  children,
  isActive,
  onBlur,
  lastItem,
  onClick,
  onFocus,
  onKeyDown,
  ...restProps
}: ListItemProps) => {
  const { theme } = useTheme()

  return (
    <li
      role='tab'
      tabIndex={0}
      className={classNames(styles.listItem, {
        [styles.isActive]: isActive,
        [styles.lightTheme]: theme.isLightThemeType,
      })}
      aria-selected={isActive}
      onClick={onClick}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      {...restProps}
    >
      {children}
    </li>
  )
}
